import { CompetitionInfo } from './../../../../data/mygolf.data';
import { Component } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';
/**
 * Created by ashok on 19/12/16.
 */
@Component({
  templateUrl: 'competition-img-expand.html',
  selector: 'competition-img-expand',
})
export class ExpandCompetitionLogo {
  /*static get parameters() {
     return [[ViewController],[NavParams]];
     }*/
  competition: CompetitionInfo;

  constructor(private viewCtrl: ModalController, private navParams: NavParams) {
    this.viewCtrl = viewCtrl;
    this.navParams = navParams;
    //this.varThing1 = this.navParams.get('param1');
    this.competition = navParams.get('competition');
  }

  close() {
    this.viewCtrl.dismiss();
  }
}
